import { DisabledPrompt, Link } from "@bcm-dev/bcms-vite";
import { TableItemContainer, TableItemTextView, TableItemView } from "components/shared";
import { UICheckbox } from "components/ui";
import React from "react";

/**
 * @function ACHParticipantsRow
 * @param {STRING} nickname - Sets the participant's nickname text.
 * @param {STRING} uid - Sets the participant's unique identifier text.
 * @param {STRING} createdDate - Sets the participant's created date text.
 * @param {STRING} groupType - Sets the participant's group type text.
 * @param {STRING} accountNumber - Sets the participant's account number text.    
 * @param {STRING} routingNumber - Sets the participant's routing number text.   
 * @param {STRING} accountType - Sets the participant's account type text.
 * @param {STRING} status - Sets the participant's current status text.
 * @return {React.Component}
 * @exported true
 * @description This is the table row used for the ACH Participants table view.
 */
export default function ACHParticipantsRow(props) {
    const participant = props.participant ?? {};
    const onParticipantRowChange = props.onParticipantRowChange ?? (() => {});
    const nickname = props.nickname ?? "[nickname]";
    const uid = props.uid  ?? "[uid]";
    const createdDate = props.createdDate ?? "[createdDate]";
    const groupType = props.groupType ?? "[groupType]";
    const accountNumber = props.accountNumber ?? "[accountNumber]";
    const routingNumber = props.routingNumber ?? "[routingNumber]";
    const accountType = props.accountType ?? "[accountType]";
    const status = props.status ?? "[status]";
    const selectedCheckboxDataPoint = props.dataPoint ? { dataPoint: `${ props.dataPoint }` } : {};

    return (
        <TableItemContainer>
            <TableItemView className="checkbox-col">
                <UICheckbox label="" value={ participant.isSelected === "true" } { ...selectedCheckboxDataPoint } onChange={ onParticipantRowChange(participant) } />
            </TableItemView>
            <TableItemView className="nickname-col">
                <DisabledPrompt>
                <Link>
                    <span className="nickname-text">{ participant.nickname }</span>
                </Link>
                </DisabledPrompt>
            </TableItemView>
            <TableItemTextView className="unique-identifier-col" text={ participant.uniqueID }/>
            <TableItemTextView className="created-col" text={<>
                <p>{participant.createdDate.format("m/d/Y")}</p>
                <p>{participant.createdTime}</p>
            </>} />
            
            <TableItemTextView className="group-col" text={ participant.group }/>
            <TableItemTextView className="account-number-col" text={ participant.number } />
            <TableItemTextView className="routing-number-col" text={ participant.routing } />
            <TableItemTextView className="account-type-col" text={ participant.accountType } />
            <TableItemTextView className="status-col" text={ participant.status }/>
        </TableItemContainer>
    )
}
